<cac-dialog-layout title="تغییر وضعیت تگ" (onSubmit)="onSubmit($event)">
    <cac-control-builder [options]="statusControl" class="mt-6"></cac-control-builder>
    <div class="min-h-60 max-h-60 overflow-y-auto border border-gray-400 rounded-1">
        <table class="table-fixed border-separate border-spacing-2 w-full">
            <thead>
                <tr>
                    <th class="w-1/2">دارایی</th>
                    <th class="w-1/3">وضعیت فعلی تگ</th>
                    <th class="w-1/6 text-center">قابل تغییر</th>
                </tr>
            </thead>
            <tbody>
                @for (item of tags(); track $index) {
                <tr>
                    <td>{{item.name}}</td>
                    <td>{{item.currentStatus}}</td>
                    @if (item.isChangable) {
                    <td class="text-green-800 text-center">✓</td>
                    }
                    @else {
                    <td class="text-error-700 text-center">✘</td>
                    }
                </tr>
                }
            </tbody>
        </table>
    </div>

</cac-dialog-layout>